// Aquí está el slice de estados UI
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  homeActive: true,
  alertsActive: false,
  ticketActive: false,
  cartActive: false,
  profileActive: false,
  // Payment modal
  paymentActive: false,
};

const mobileFixedBottomMenuSlice = createSlice({
  name: "mobileFixedBottomMenu",
  initialState,
  reducers: {
    setHomeActive: (state) => {
      state.homeActive = !state.homeActive;
      state.alertsActive = false;
      state.ticketActive = false;
      state.cartActive = false;
      state.profileActive = false;
      state.paymentActive = false;
    },
    setAlertsActive: (state) => {
      state.alertsActive = !state.alertsActive;
      state.homeActive = false;
      state.ticketActive = false;
      state.cartActive = false;
      state.profileActive = false;
      state.paymentActive = false;
    },
    setTicketActive: (state) => {
      state.ticketActive = !state.ticketActive;
      state.homeActive = false;
      state.alertsActive = false;
      state.cartActive = false;
      state.profileActive = false;
      state.paymentActive = false;
    },
    setCartActive: (state) => {
      state.cartActive = !state.cartActive;
      state.homeActive = false;
      state.alertsActive = false;
      state.ticketActive = false;
      state.profileActive = false;
      state.paymentActive = false;
    },
    setProfileActive: (state) => {
      state.profileActive = !state.profileActive;
      state.homeActive = false;
      state.alertsActive = false;
      state.ticketActive = false;
      state.cartActive = false;
      state.paymentActive = false;
    },
    setPaymentActive: (state) => {
      state.paymentActive = !state.paymentActive;
      state.homeActive = false;
      state.alertsActive = false;
      state.ticketActive = false;
      state.cartActive = false;
      state.profileActive = false;
    },
    resetState: (state) => {
      state.homeActive = true;
      state.alertsActive = false;
      state.ticketActive = false;
      state.cartActive = false;
      state.profileActive = false;
      state.paymentActive = false;
    }
  },
});

export const {
  setHomeActive,
  setAlertsActive,
  setTicketActive,
  setCartActive,
  setProfileActive,
  setPaymentActive,
  resetState,
} = mobileFixedBottomMenuSlice.actions;

export default mobileFixedBottomMenuSlice.reducer;
